import cadastro from '../api/cadastro'

export async function validatePJData(
  body,
  addToast,
  handleReceitaFederalErrorChange
) {
  try {
    const response = await cadastro.validarReceitaFederal(body)
    if (response.status === 200) {
      return 'valid'
    }

    function filterMessage(message) {
      if (message.includes('Nome Fantasia')) {
        return 'nome_fantasia'
      } else if (message.includes('Razão Social')) {
        return 'razao_social'
      } else if (message.includes('Inscrição Estadual')) {
        return 'inscricao_estadual'
      } else if (message.includes('Inscrição Municipal')) {
        return 'inscricao_municipal'
      } else if (message.includes('CNPJ nao encontrado na Receita Federal')) {
        return 'cnpj'
      } else if (message.includes('CEP de Faturamento')) {
        return 'cep'
      } else if (message.includes('Número do Endereco')) {
        return 'numero'
      } else if (
        message.includes(
          'CNPJ da consulta não cadastrado como contribuinte na UF'
        )
      ) {
        return 'inscricao_estadual'
      }
    }

    if (response.status === 400) {
      addToast({
        type: 'error',
        title: response.data,
        description: '',
        timer: 8000
      })

      switch (filterMessage(response.data)) {
        case 'razao_social':
          handleReceitaFederalErrorChange(true, 'razaoSocial', response.data)
          break

        case 'nome_fantasia':
          handleReceitaFederalErrorChange(true, 'nomeFantasia', response.data)
          break

        case 'cnpj':
          handleReceitaFederalErrorChange(true, 'cnpj', response.data)
          break

        case 'inscricao_estadual':
          handleReceitaFederalErrorChange(
            true,
            'inscricaoEstadual',
            response.data
          )
          break

        case 'inscricao_municipal':
          handleReceitaFederalErrorChange(
            true,
            'inscricaoMunicipal',
            response.data
          )
          break

        case 'cep':
          handleReceitaFederalErrorChange(true, 'cep', response.data)
          break

        case 'numero':
          handleReceitaFederalErrorChange(true, 'numero', response.data)
          break

        case 'uf':
          handleReceitaFederalErrorChange(true, 'uf', response.data)
          break

        default:
          break
      }
    }
  } catch (error) {
    addToast({
      type: 'error',
      title: 'Ocorreu um erro ao realizar cadastro',
      description: 'API da Receita Federal sem resposta'
    })
  }
}
